var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "18px",
    viewBox: "0 0 9 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "red"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "screendesigns",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing-page",
    transform: "translate(-30.000000, -1366.000000)",
    fillRule: "nonzero",
    stroke: "rgb(23,25,38)",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "bekannt-aus",
    transform: "translate(0.000000, 1226.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ui/controller/arrow-left",
    transform: "translate(18.000000, 131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.000000, 18.000000) rotate(-180.000000) translate(-18.000000, -18.000000) ",
    id: "Path-7"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "15.84 10.56 23.04 18 15.84 25.44"
  }))))))));
};
export default SvgArrowRight;